import { StackProps, Typography } from "@mui/material"
import { Stack } from "src/shared/components"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
const AccessDenied = ({ sx, ...rest }: StackProps) => {
  return (
    <Stack variant="columnCenter" sx={{ height: "100%", ...sx }} {...rest}>
      <InfoOutlinedIcon fontSize="large" />
      <Typography variant="body1">You do not have access to this content</Typography>
      <Typography variant="body2" color="textSecondary">
        We're sorry, your account does not have permission to this content
      </Typography>
    </Stack>
  )
}

export default AccessDenied
